import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const AboutLayout = () => (
  <div className="container">
    <div className="inner">
      <ul className="list-inline text-start h6 mb-3">
        <li className="list-inline-item">
          <Link to="/about/about-app">About App</Link>
        </li>
        <li className="list-inline-item ms-2">
          <Link to="/about/about-author">About Author</Link>
        </li>
      </ul>
      <Outlet />
    </div>
  </div>
);
export default AboutLayout;
